class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    // Get references to key elements in the Light DOM
    this.dropdown = this.querySelector('.dropdown');
    this.trigger = this.querySelector('.trigger');
    this.menu = this.querySelector('.menu');
    this.items = this.querySelectorAll('.item');
    this.hiddenInput = this.querySelector("input[type='hidden']");
  }

  connectedCallback() {
    // Initialize dropdown
    this.initializeDropdown();

    // Add event listeners
    this.trigger.addEventListener('click', () => this.toggleMenu());
    this.trigger.addEventListener('keydown', (e) => this.handleTriggerKeydown(e));
    document.addEventListener('click', (e) => this.handleOutsideClick(e));
    this.items.forEach((item) => item.addEventListener('keydown', (e) => this.handleItemKeydown(e)));
    this.menu.addEventListener('click', (e) => this.handleItemClick(e));
  }

  disconnectedCallback() {
    // Cleanup event listeners
    this.trigger.removeEventListener('click', this.toggleMenu);
    this.trigger.removeEventListener('keydown', this.handleTriggerKeydown);
    document.removeEventListener('click', this.handleOutsideClick);
    this.items.forEach((item) => item.removeEventListener('keydown', this.handleItemKeydown));
    this.menu.removeEventListener('click', this.handleItemClick);
  }

  initializeDropdown() {
    // Initialize selected item based on the "selected" attribute
    const selectedItem = [...this.items].find((item) => item.hasAttribute('aria-selected') && item.getAttribute('aria-selected') === 'true');
    if (selectedItem) {
      this.updateSelectedItem(selectedItem);
    } else {
      this.trigger.querySelector('.selected').textContent = 'Select an option';
    }
  }

  toggleMenu() {
    const isExpanded = this.menu.classList.contains('active');
    this.menu.classList.toggle('active');
    this.trigger.setAttribute('aria-expanded', !isExpanded);
    this.dropdown.setAttribute('aria-expanded', !isExpanded);
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.menu.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.dropdown.setAttribute('aria-expanded', 'false');
    }
  }

  handleTriggerKeydown(event) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.menu.classList.add('active');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.items[0].focus();
    }
  }

  handleItemKeydown(event) {
    const currentItem = event.target;
    const currentIndex = [...this.items].indexOf(currentItem);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextItem = this.items[currentIndex + 1] || this.items[0];
      nextItem.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevItem = this.items[currentIndex - 1] || this.items[this.items.length - 1];
      prevItem.focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.updateSelectedItem(currentItem);
      this.menu.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.menu.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.focus();
    }
  }

  handleItemClick(event) {
    const item = event.target.closest('.item');
    if (item) {
      this.updateSelectedItem(item);
      this.menu.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  updateSelectedItem(item) {
    // Update selected display
    this.trigger.querySelector('.selected').textContent = item.textContent;

    // Update hidden input value
    this.hiddenInput.value = item.getAttribute('data-value');

    // Update aria-selected state
    this.items.forEach((i) => i.setAttribute('aria-selected', 'false'));
    item.setAttribute('aria-selected', 'true');
  }
}

customElements.define('custom-dropdown', CustomDropdown);
